import { Layout } from 'react-admin';
import { CustomMenu as Menu } from './Menu';
import { CustomAppBar as AppBar } from './AppBar';

export const CustomLayout = props => <Layout {...props} menu={Menu} appBar={AppBar} />;